import { __t } from '../i18n/t'

/**
 * `required()` do react-admin aceita texto só com espaços ("   " passa). No login isso
 * chegava ao backend como credencial inválida. Mesma mensagem padrão do `required()`.
 */
export const requiredTrim = () => (value: unknown) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
    ? 'ra.validation.required'
    : undefined

/**
 * Cadastro de usuário sem rede: o campo Rede só aparece para admin, e o admin sem rede na
 * barra e sem escolher no formulário mandava POST /employees sem chainId ("Rede não definida").
 * `getSelectedChainId` devolve a rede que o provider injetaria (getChainId()); é função para ler a
 * escolha atual da barra na hora de validar, não a do render.
 */
export const validateChainSelected = (getSelectedChainId: () => string | null | undefined) => (values: { chainId?: string | null }) =>
  values?.chainId || getSelectedChainId() ? {} : { chainId: __t('Selecione uma rede') }
